import { InjectionToken } from '@angular/core';

declare global {
    interface Window {
        dataLayer: any[];
        google_tag_manager: any[];
    }
}

declare module '@df/core/df-core.config' {
    export interface IDfConfig {
        gtm?: {
            /**
             * Container id
             */
            id?: string;
            /**
             * Container env
             */
            env?: string;
            /**
             * Container auth
             */
            auth?: string;
        };
    }
}

export namespace NModuleGtm {
    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_MODULE_GTM_OPTIONS');

    export interface IModuleOptions {
        /**
         * List of fields picked to pass to GTM
         */
        customerFields: string[];
        /**
         * Impression tracking
         */
        view:
            | {
                  mode: 'init';
              }
            | {
                  mode: 'viewport';
                  tollerance?: number;
              };
        includeTax: boolean; //  defaults to true for legacy support
    }
}
